import {
    GetSubscriptionDetailsQuery,
    GetSubscriptionDetailsQueryVariables,
    SubscriptionDetails
} from "../../../API";

import { API } from "aws-amplify";
import { AuthIDTokenSupplierFactory } from "../../auth/AuthIDTokenSupplierFactory";
import ClientLogger from "../../logging/ClientLogger";
import ClientLoggerFactory from "../../logging/ClientLoggerFactory";
import { GraphQLQuery } from "@aws-amplify/api";
import { IDTokenSupplier } from "../../auth/IDTokenSupplier";
import { SubscriptionDetailDAO } from "./SubscriptionDetailDAO";
import { getSubscriptionDetails } from "../../../graphql/queries";

export class GraphQLSubscriptionDetailDAO implements SubscriptionDetailDAO {
    private static readonly GET_SUBSCRIPTION_DETAILS_ATTEMPT_METRIC_NAME = "GraphQLSubscriptionDetailDAO.GetSubscriptionDetails.Attempt";
    private static readonly GET_SUBSCRIPTION_DETAILS_FAILURE_METRIC_NAME = "GraphQLSubscriptionDetailDAO.GetSubscriptionDetails.Error";

    constructor(
        private readonly idTokenSupplier: IDTokenSupplier,
        private logger: ClientLogger
    ) { }

    public async getSubscriptionDetails(): Promise<SubscriptionDetails | null | undefined> {
        try {
            this.logger.info(
                "Getting subscription details",
                undefined,
                [GraphQLSubscriptionDetailDAO.GET_SUBSCRIPTION_DETAILS_ATTEMPT_METRIC_NAME]
            );
            const authToken: string = await this.idTokenSupplier.get();
            const result = await API.graphql<GraphQLQuery<GetSubscriptionDetailsQuery>>({
                query: getSubscriptionDetails,
                variables: {} satisfies GetSubscriptionDetailsQueryVariables,
                authToken
            });
            return result.data?.getSubscriptionDetails;
        } catch (error) {
            this.logger.error(
                "Failed to get subscription details",
                error,
                [GraphQLSubscriptionDetailDAO.GET_SUBSCRIPTION_DETAILS_FAILURE_METRIC_NAME]
            );
            throw error;
        }
    }
}

export const graphQLSubscriptionDetailDAO = new GraphQLSubscriptionDetailDAO(
    AuthIDTokenSupplierFactory.getInstance(),
    ClientLoggerFactory.getClientLogger("GraphQLSubscriptionDetailDAO")
);